import { pick, retryInSeconds, stripUndefined } from 'ts-utils';
import { ApiClient } from '../../../api/ApiClient';
import {
  AVAILABLE_ADDON_PLANS,
  AVAILABLE_ONE_CLICK_UPSELL_PLANS,
  AVAILABLE_PLANS,
  AVAILABLE_TRIAL_PLANS,
  BASELINE_PURCHASE_PLAN,
} from '../../../businessLogic/PlansData';
import { recordError } from '../../../util/Errors';
import { makeUserFriendlyError } from '../../../util/UserFriendlyError';
import { ActionType } from '../../ActionTypes';
import { store as baseStore } from '../../Store';

// Retry the getPrices call up to 3 times, with a back-off interval of 0.2, 5, and 30 seconds.
const RETRY_INTERVAL_SECONDS = [0.2, 5, 30];

/** Fetch the pricing for the given items, coupon code and currency, and update the store with the results. */
export async function fetchPrices(store = baseStore): Promise<void> {
  try {
    store.dispatch({ type: ActionType.FETCH_PRICES_LOADING });

    const result = await retryInSeconds(RETRY_INTERVAL_SECONDS, async () => {
      const { pricing } = store.getState();

      return await new ApiClient().getPrices({
        items: [
          ...AVAILABLE_PLANS,
          BASELINE_PURCHASE_PLAN,
          ...AVAILABLE_ONE_CLICK_UPSELL_PLANS,
          ...AVAILABLE_TRIAL_PLANS,
          ...AVAILABLE_ADDON_PLANS,
        ],
        ...stripUndefined(pick(pricing, ['currency', 'couponCode'])),
      });
    });

    store.dispatch({ type: ActionType.FETCH_PRICES_SUCCESS, result });
  } catch (rawError) {
    const error = makeUserFriendlyError(rawError, 'Failed to get pricing');
    recordError(error);

    store.dispatch({ type: ActionType.FETCH_PRICES_FAILURE, error });
  }
}
